import { token } from '@atlaskit/tokens';

import { GoalPhase, ScoreStatus, GoalStatus, LozengeStyle } from './types';

export const fixScore = (score: number | null | undefined) =>
  score === null || score === undefined ? null : score > 1 ? score / 100 : score;

export const GOAL_STATUSES: { [key in ScoreStatus]: GoalStatus & { name: ScoreStatus } } = {
  // There's no such thing as 'pending' status. This is kept here for legacy / backward-compatibility reason
  pending: {
    id: 'pending',
    displayName: 'Pending',
    name: 'pending',
  },
  on_track: {
    id: 'on_track',
    displayName: 'On track',
    name: 'on_track',
  },
  at_risk: {
    id: 'at_risk',
    displayName: 'At risk',
    name: 'at_risk',
  },
  off_track: {
    id: 'off_track',
    displayName: 'Off track',
    name: 'off_track',
  },
};

// Convert a goal score to a status object
export const goalScoreToStatusEntity = (score?: number | null, phase?: GoalPhase | null) => {
  if ((phase && ['done', 'in_progress'].includes(phase) === false) || score === null || score === undefined) {
    return GOAL_STATUSES.pending;
  }

  if (score > 1) {
    score = fixScore(score) ?? 0;
  }

  if (score < 0.4) {
    return GOAL_STATUSES.off_track;
  }

  if (score < 0.7) {
    return GOAL_STATUSES.at_risk;
  }

  return GOAL_STATUSES.on_track;
};

const onTrackStatusLozengeStyle: LozengeStyle = {
  backgroundColor: `${token('color.background.accent.green.subtlest')}`,
  color: `${token('color.text.accent.green')}`,
};
const atRiskStatusLozengeStyle: LozengeStyle = {
  backgroundColor: `${token('color.background.accent.yellow.subtlest')}`,
  color: `${token('color.text.accent.orange')}`,
};
const offTrackStatusLozengeStyle: LozengeStyle = {
  backgroundColor: `${token('color.background.accent.red.subtlest')}`,
  color: `${token('color.text.accent.red')}`,
};
const defaultStatusLozengeStyle: LozengeStyle = {
  backgroundColor: `${token('color.background.accent.gray.subtlest')}`,
  color: `${token('color.text.accent.gray')}`,
};

export const StatusLozengeStyles = {
  ON_TRACK: onTrackStatusLozengeStyle,
  AT_RISK: atRiskStatusLozengeStyle,
  OFF_TRACK: offTrackStatusLozengeStyle,
  DEFAULT: defaultStatusLozengeStyle,
};
